const getBefore = (context, layers) => {
  const { map } = context

  const before = layers.find(layer => map.getLayer(layer))
  console.log('before', before)

  return before
}

export default getBefore



// WEBPACK FOOTER //
// ./src/utility/getBefore.js